import _taggedTemplateLiteral from "/home/opc/is-monorepo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  fragment questionOptionInfo on QuestionOption {\n    id\n    value\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
import gql from 'graphql-tag';
export default gql(_templateObject());